/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlacklistTokenRequest } from '../../models/blacklist-token-request';
import { ServiceAccountToken } from '../../models/service-account-token';

export interface UpdateTokenBlacklistedStatus$Params {

/**
 * Id of a resource.
 */
  id: string;

/**
 * Id of a resource.
 */
  token_id: string;
      body: BlacklistTokenRequest
}

export function updateTokenBlacklistedStatus(http: HttpClient, rootUrl: string, params: UpdateTokenBlacklistedStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceAccountToken>> {
  const rb = new RequestBuilder(rootUrl, updateTokenBlacklistedStatus.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.path('token_id', params.token_id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServiceAccountToken>;
    })
  );
}

updateTokenBlacklistedStatus.PATH = '/api/v1/service_account_users/{id}/tokens/{token_id}';
